import React, { Component } from 'react';
import { __ } from 'i18n/index';
import { Request } from 'components/Request';

import { UserComponent } from 'react/UserComponent';
import { CircleLoaderComponent } from 'react/CircleLoaderComponent';

import ExpandingTextarea from 'react/elements/ExpandingTextarea';

import PostGroupTopic from 'models/PostGroupTopic';
import AutolinkedTextComponent from '../elements/AutolinkedTextComponent';
import ActiveSelectableButton from "../elements/ActiveSelectableButton";
import LadderTime, { formatLadderTime } from 'react/elements/LadderTime';

export default class PostTopic extends Component {
	static updateInterval = 40000;

	constructor(props) {
		super(props);
		const { topic, parentTopic } = this.props;
		this.state = {
			replies: [],
			retrievingReplies: null,

			repliesOpen: false,

			composerRequested: false,
			replyContent: '',
			submittingReply: false,

			editing: false,
			submittingEdit: false,
			editingPostContent: topic.content,

			deleted: false,
			timeAgo: topic.time.fromNow()
		};

		this.getReplies = this.getReplies.bind(this);
		this.toggleRepliesOpen = this.toggleRepliesOpen.bind(this);
		this.onReplyContentChange = this.onReplyContentChange.bind(this);
		this.editOnChange = this.editOnChange.bind(this);

		this.editPost = this.editPost.bind(this);
		this.submitEdit = this.submitEdit.bind(this);

		this.deletePost = this.deletePost.bind(this);

		this.replyToTopic = this.replyToTopic.bind(this);
	}

	componentDidMount() {
		const { topic } = this.props;
		this.updateInterval = setInterval(() => {
			this.setState({
				timeAgo: topic.time.fromNow()
			});
		}, PostTopic.updateInterval);
	}

	componentWillUnmount() {
		clearInterval(this.updateInterval);
	}

	editOnChange(e) {
		this.setState({
			editingPostContent: e.target.value
		});
	}

	editPost() {
		const { editing } = this.state;

		this.setState({
			editing: !editing
		});
	}

	deletePost() {
		const { topic } = this.props;
		const doIt = confirm('Remove this post?');
		if(!doIt) {
			return false;
		}
		const data = {
			post_id: topic.id
		};
		Request.post(siteUrl + '/posts/delete_post', data)
			.then(() => {
				this.setState({
					deleted: true
				});
			})
			.catch(Request.generalJsonError);
	}

	submitEdit() {
		const { topic } = this.props;
		const { editingPostContent } = this.state;

		const data = {
			post_id: topic.id,
			message: editingPostContent,
		};
		this.setState({
			submittingEdit: true
		});
		Request.post(siteUrl + '/posts/submit_post_reply', data)
			.then((response) => {
				topic.update(response.reply);
				this.setState({
					editing: false
				});
			})
			.catch(Request.generalJsonError)
			.finally(() => {
				this.setState({
					submittingEdit: false
				});
			});
	}

	replyToTopic() {
		const { topic } = this.props;
		const { replyContent } = this.state;
		const submission = {};

		submission.parent_post_id = topic.id;
		submission.message = replyContent;

		this.setState({
			submittingReply: true
		});
		Request.post(siteUrl + '/posts/submit_post_reply', submission)
			.then((response) => {
				this.setState((state) => {
					const replies = [...state.replies];
					replies.push(PostGroupTopic.create(response.reply));
					return {
						replyContent: '',
						replies,
						repliesOpen: true,
					};
				});

			})
			.catch(Request.generalJsonError)
			.finally(() => {
				this.setState({
					submittingReply: false
				});
			});
	}

	toggleRepliesOpen() {
		const { repliesOpen } = this.state;
		if(repliesOpen) {
			this.setState({
				repliesOpen: false
			});
		}
		else {
			this.setState({
				repliesOpen: true
			});
			this.getReplies();
		}
	}

	getReplies() {
		const { topic } = this.props;
		this.setState({ retrievingReplies: true });
		Request.post(siteUrl + '/posts/get_replies', { get_replies: topic.id })
			.then((response) => {
				this.setState({
					replies: response.replies.map((reply) => {
						return PostGroupTopic.create(reply);
					})
				});
			})
			.finally(() => {
				this.setState({ retrievingReplies: false });
			});
	}

	onReplyContentChange(e) {
		this.setState({ replyContent: e.target.value });
	}

	render() {
		const { topic, parentTopic, isNotes, hideComposer = false } = this.props;
		const {
			replyContent,
			composerRequested,
			repliesOpen,
			replies,
			retrievingReplies,
			deleted,
			editing,
			editingPostContent,
			submittingReply,
			submittingEdit,
			timeAgo,
		} = this.state;

		const totalReplies = replies.length || topic.replies_count;

		if(deleted) {
			return null;
		}
		return (
			<div
				className={`editable-toggle post-replyable post-editable post-deletable panel-body ${parentTopic ? 'wall-post-reply ' : 'panel wall_post '}`}
				id={`site_post_${topic.id}`}>

			    <span className='post_time emphasized_time'>
					{hideComposer && <span className='ui-avatar' aria-hidden='true'>{topic.sender.username?.slice(0, 1)}</span>}
				    {!isNotes &&
				    <UserComponent user={topic.sender} />
				    }

				    <div className='the_rest'>
					    <div>
					    {topic.permissions.edit &&
					    <ActiveSelectableButton
						    onClick={this.editPost}
						    title='edit'
						    className='btn btn-sm shadowed-btn active_selectable_button edit_post'>
						    <i className='fa fa-pencil' />
					    </ActiveSelectableButton>
					    }
						    {topic.permissions.delete &&
						    <ActiveSelectableButton
							    onClick={this.deletePost}
							    role='button'
							    title='delete'
							    className='btn btn-sm shadowed-btn active_selectable_button delete_post'>
							    <i className='fa fa-times' />
						    </ActiveSelectableButton>
						    }
					    </div>

					    <time title={formatLadderTime(topic.time, 'fullWithWeekday')}>{topic.time.fromNow()}</time>
				    </div>

			    </span>
				{!editing &&
				<div className='response wall_message'>
					<AutolinkedTextComponent
						text={topic.content}
					/>
				</div>
				}
				{editing &&
				<div className='edit_mode'>
					<div className='reply_to_post sub_post'>
						<ExpandingTextarea
							onChange={this.editOnChange}
							className='materialize-textarea'
							name='message'
							disabled={submittingEdit}
							value={editingPostContent}
						/>
						<button
							disabled={submittingEdit}
							onClick={this.submitEdit}
							className='btn active_selectable_button shadowed-btn btn-block submit_comment'>Submit Edit
						</button>
					</div>
				</div>
				}

				<div className={`${parentTopic ? '' : 'replies-list'} ${repliesOpen ? 'open' : 'closed'}`}>
					<div className='entries panel-body'>
						{!parentTopic && totalReplies > 0 &&
						<button
							onClick={this.toggleRepliesOpen}
							className={`reply-toggle btn btn-sm shadowed-btn active_selectable_button ${retrievingReplies ? 'disabled' : ''}`}>
							<span className='replies_number'>{totalReplies}</span>{' '}
							<span className='replies_word'>{totalReplies === 1 ? 'Reply' : 'Replies'}</span>{' '}
							{!repliesOpen &&
							<i className='fa closed fa-chevron-down' />
							}
							{repliesOpen &&
							<i className='fa opened fa-chevron-up' />
							}
						</button>
						}
						{' '}
						{false && !parentTopic &&
						<span className='last_activity'>Last Activity: <LadderTime className='last_activity_time' time={topic.last_activity} /></span>
						}

						{repliesOpen &&
						<div className='replies' data-replies=''>
							{retrievingReplies && !replies.length &&
							<CircleLoaderComponent />
							}
							{replies.map((reply) => (
								<PostTopic
									key={reply.id}
									topic={reply}
									parentTopic={topic}
								/>
							))}
						</div>
						}
					</div>
					{hideComposer && !composerRequested && !parentTopic && !isNotes && !editing && !topic.permissions.closed &&
						<button type='button' className='bug-workspace-topic-reply ui-button ui-button--link' onClick={() => {
							this.setState({ composerRequested: true });
							if(totalReplies > 0 && !repliesOpen) this.toggleRepliesOpen();
						}}>{__('Reply')}</button>
					}
					{(hideComposer ? composerRequested : (repliesOpen || totalReplies === 0)) && !parentTopic && !isNotes && !editing &&
					<React.Fragment>
						{topic.permissions.closed &&
						<div className='cannot_post'>
							You cannot post here currently
						</div>
						}
						{!topic.permissions.closed &&
						<div className='reply_to_post add_new_post'>
							<ExpandingTextarea
								placeholder={__('Add a comment...')}
								className='reply_textarea materialize-textarea'
								name='message'
								onChange={this.onReplyContentChange}
								value={replyContent}
								disabled={submittingReply}
							/>
							<ActiveSelectableButton
								onClick={this.replyToTopic}
								className={`submit_comment ${submittingReply ? 'disabled' : ''}`}>
								{__('Reply')}
							</ActiveSelectableButton>
						</div>
						}
					</React.Fragment>
					}
				</div>

			</div>
		);
	}
}